module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container choose-packages choose-packages-box"
  }, [_c('div', {
    staticClass: "content text-center"
  }, [_c('div', {
    staticClass: "new-device-btn"
  }, [_c('div', {
    staticClass: "numer-of-devies"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("numberOfDevices")))])]), _vm._v(" "), _c('div', _vm._l((_vm.devices), function(item) {
    return _c('button', {
      key: item,
      class: [{
          'choose-device': item === _vm.currentDevice
        },
        'line-button' ],
      on: {
        "mouseover": function($event) {
          return _vm.chooseDevice(item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    class: [
      'col-' + _vm.currentCol + '-box',
      'all-packages',
      'packages-list-box' ]
  }, [_vm._l((_vm.packages), function(item, index) {
    return [_c('packageItem', {
      key: 'pkg' + index,
      attrs: {
        "item": item,
        "index": index,
        "currentPackage": _vm.currentPackage
      },
      on: {
        "click-button": function($event) {
          return _vm.trakPackage(item)
        }
      },
      nativeOn: {
        "mouseover": function($event) {
          _vm.currentPackage = item
        }
      }
    })]
  })], 2), _vm._v(" "), _c('h2', {
    staticClass: "enjoy-title"
  }, [_vm._v(_vm._s(_vm.$t("unlimitedTraffic")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26c5101b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/choosePackage/ChoosePackageNew.vue
// module id = 1284
// module chunks = 1